export default {"src":"/_next/static/media/bcio.a8f31c8e.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};